import { httpClient } from "@/shared/api";

import type { ServiceCategory } from "../model/types";
import type {
  CreateServiceCategoryRequestDTO,
  ListServiceCategoriesResponseDTO,
  RenameServiceCategoryRequestDTO,
  ServiceCategoryResponseDTO,
} from "./dto";

function toDomain(dto: ServiceCategoryResponseDTO): ServiceCategory {
  return {
    id: dto.id,
    name: dto.name,
  };
}

/** `GET /api/service-categories` — усі категорії компанії. */
export async function listCategories(): Promise<ServiceCategory[]> {
  const { data } = await httpClient.get<ListServiceCategoriesResponseDTO>("/service-categories");
  return data.categories.map(toDomain);
}

/** `POST /api/service-categories` — створює категорію; 201 → доменний `ServiceCategory`. */
export async function createCategory(name: string): Promise<ServiceCategory> {
  const body: CreateServiceCategoryRequestDTO = { name };
  const { data } = await httpClient.post<ServiceCategoryResponseDTO>("/service-categories", body);
  return toDomain(data);
}

/** `PATCH /api/service-categories/{id}` — перейменування; 200 → доменний `ServiceCategory`. */
export async function renameCategory(id: string, name: string): Promise<ServiceCategory> {
  const body: RenameServiceCategoryRequestDTO = { name };
  const { data } = await httpClient.patch<ServiceCategoryResponseDTO>(
    `/service-categories/${id}`,
    body,
  );
  return toDomain(data);
}

/** `DELETE /api/service-categories/{id}` — видалення; 204 без тіла. */
export async function removeCategory(id: string): Promise<void> {
  await httpClient.delete(`/service-categories/${id}`);
}
